import { useRef, useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { useRealm, useT } from "~/util/Lang";
import { AdenaColor } from "./Adena";
import { CrystalName } from "./Crystal";
import css from "./CrystalCalc.module.css";

function parseValue(value: string): number | null {
  const parsed = parseInt(value.trim());
  if (isNaN(parsed)) {
    return null;
  }
  return parsed;
}

export function CrystalCalc(props: {
  crystalCount: number;
  defaultPrice: number;
  crystalType: string;
}) {
  const crysCount = props.crystalCount;
  const [itemPrice, setItemPrice] = useState(() =>
    props.defaultPrice.toString()
  );
  const [crysPrice, setCrysPrice] = useState(() =>
    Math.round(props.defaultPrice / props.crystalCount).toString()
  );
  const t = useT();
  const { lang } = useRealm();
  const itemRef = useRef<HTMLInputElement>(null);
  const crysRef = useRef<HTMLInputElement>(null);
  useHotkeys("i", (e) => {
    itemRef.current?.focus();
    itemRef.current?.select();
    e.preventDefault();
  });
  useHotkeys("k", (e) => {
    crysRef.current?.focus();
    crysRef.current?.select();
    e.preventDefault();
  });

  return (
    <div>
      <div className={css.desc}>
        <div>{t({ en: "Item price", ru: "Цена предмета" })}:</div>
        <div className={css.descRight}>
          <div className="hotkey">
            <span>{t({ en: "press", ru: "нажми" })}</span>
            <span className="kbt">I</span>
          </div>
        </div>
      </div>
      <input
        ref={itemRef}
        className={css.input}
        style={{ color: AdenaColor() }}
        value={itemPrice}
        onChange={(e) => {
          const itemPriceNum = parseValue(e.target.value);
          setItemPrice(e.target.value);
          if (itemPriceNum != null) {
            setCrysPrice(Math.round(itemPriceNum / crysCount).toString());
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.currentTarget.blur();
          }
        }}
      />

      <div style={{ height: 10 }} />

      <div className={css.desc}>
        <div>
          {lang === "en" ? (
            <>
              1 <CrystalName type={props.crystalType} /> Price:
            </>
          ) : (
            <>
              Цена 1 <CrystalName type={props.crystalType} />:
            </>
          )}
        </div>
        <div className={css.descRight}>
          <div className="hotkey">
            <span>{t({ en: "press", ru: "нажми" })}</span>
            <span className="kbt">K</span>
          </div>
        </div>
      </div>
      <div>
        <input
          ref={crysRef}
          className={css.input}
          style={{ color: AdenaColor() }}
          value={crysPrice}
          onChange={(e) => {
            const crysPriceNum = parseValue(e.target.value);
            setCrysPrice(e.target.value);
            if (crysPriceNum != null) {
              setItemPrice(Math.round(crysPriceNum * crysCount).toString());
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              e.currentTarget.blur();
            }
          }}
        />
      </div>
    </div>
  );
}
